import MicroModal from 'micromodal';

export function initializeConfirmModal() {
    if (document.getElementById('modal-template')) return;

    const modalHTML = `
    <div class="modal micromodal-slide" id="modal-template" aria-hidden="true">
      <div class="modal__overlay" tabindex="-1" data-micromodal-close>
        <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-title">
          <header class="modal__header">
            <h2 id="modal-title"></h2>
          </header>
          <main class="modal__content" id="modal-content"></main>
          <footer class="modal__footer">
            <button class="button" id="modal-confirm">확인</button>
            <button class="button" id="modal-cancel" data-micromodal-close>취소</button>
          </footer>
        </div>
      </div>
    </div>
  `;
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    MicroModal.init();
}

export function showConfirmModal({ title, message, confirmText = '확인', cancelText = '취소' }) {
    return new Promise(resolve => {
        document.getElementById('modal-title').textContent = title;
        document.getElementById('modal-content').textContent = message;
        document.getElementById('modal-confirm').textContent = confirmText;
        document.getElementById('modal-cancel').textContent = cancelText;

        const confirmBtn = document.getElementById('modal-confirm');
        const cancelBtn = document.getElementById('modal-cancel');

        confirmBtn.onclick = () => {
            MicroModal.close('modal-template');
            resolve(true);
        };
        cancelBtn.onclick = () => {
            MicroModal.close('modal-template');
            resolve(false);
        };

        MicroModal.show('modal-template');
    });
}
